import api from './client';
import type { ApiResponse, FormularioEngenharia } from '@engenharia/shared';

export async function criarFormulario(data: Record<string, unknown>): Promise<{ id: number }> {
  const res = await api.post<ApiResponse<{ id: number }>>('/formularios', data);
  return res.data.data!;
}

export async function buscarFormulario(id: number): Promise<FormularioEngenharia> {
  const res = await api.get<ApiResponse<FormularioEngenharia>>(`/formularios/${id}`);
  return res.data.data!;
}

export async function atualizarFormulario(id: number, data: Record<string, unknown>): Promise<void> {
  await api.put(`/formularios/${id}`, data);
}

export async function enviarFormulario(id: number): Promise<void> {
  await api.post(`/formularios/${id}/enviar`);
}
